/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { unsubscribeFromAllNotificationsRequest } from 'domains/user';
import { EstimateCard } from 'pages/SettingsPage/NotificationCenter/EstimateCard';
import { MyNetwork } from 'pages/SettingsPage/NotificationCenter/MyNetwork';
import { OrdersCard } from 'pages/SettingsPage/NotificationCenter/OrdersCard';
import { Flex, Text, WhiteButton } from 'UI';

export const NotificationSettings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClickUnsubscribe = () => {
    dispatch(unsubscribeFromAllNotificationsRequest());
  };

  return (
    <Flex direction={'column'} gap={25} padding={'25px 0'} maxWidth={1000}>
      <EstimateCard />
      <OrdersCard />
      <MyNetwork />
      <Flex direction={'column'} gap={5}>
        <div>
          <WhiteButton onClick={handleClickUnsubscribe}>
            {t('settings.notification_center.unsubscribe', 'Unsubscribe from all of the above')}
          </WhiteButton>
        </div>
        <Text type="base" color="grey55">
          {t(
            'settings.notification_center.unsubscribe.description',
            "Please note: you'll still receive important administrative emails, such as password resets.",
          )}
        </Text>
      </Flex>
    </Flex>
  );
};
